import { N as s, i as h, g as o, S as d, a as g } from "./network-mzdvQxSG.js";
const p = "https://manifold.gallery";
function c(e) {
  const a = h(e) ? "https://testnets.opensea.io" : "https://opensea.io";
  let t = o(e);
  return t === "mainnet" && (t = "ethereum"), e === 137 && (t = "matic"), `${a}/assets/${t}`;
}
function U(e, a) {
  return `${c(e)}/${a}`;
}
function R(e, a, t) {
  return `${c(e)}/${a}/${t}`;
}
function $(e, a) {
  if (e !== s.Mainnet)
    throw new Error("Unsupported Network passed to getLooksRareCollectionURL");
  return `https://looksrare.org/collections/${a}`;
}
function m(e, a, t) {
  if (e !== s.Mainnet)
    throw new Error("Unsupported Network passed to getLooksRareTokenURL");
  return `https://looksrare.org/collections/${a}/${t}`;
}
function i(e) {
  switch (e) {
    case s.Optimism:
      return "https://optimistic.etherscan.io";
    case s.Sepolia:
      return "https://sepolia.etherscan.io";
    case s.Base:
      return "https://basescan.org";
    case s.Mainnet:
      return "https://etherscan.io";
    case s.Matic:
      return "https://polygonscan.com";
    default:
      throw new Error("Unsupported Network passed to getEtherscanBaseURL");
  }
}
function L(e, a, t) {
  return `${i(e)}/nft/${a}/${t}`;
}
function w(e, a) {
  return `${i(e)}/tx/${a}`;
}
function l(e, a) {
  return `${i(e)}/address/${a}`;
}
function k(e, a) {
  return l(e, a);
}
function y(e, a) {
  return l(e, a);
}
function f(e) {
  return e === 1 ? "https://gallery.manifold.xyz" : e === 137 ? "https://gallery.manifold.xyz/matic" : `https://gallery.manifold.xyz/${o(e)}`;
}
function N(e, a, t) {
  if (![s.Mainnet, s.Matic, s.Base].includes(e))
    throw new Error("Unsupported Network passed to getMagicEdenTokenURL");
  let n = o(e);
  return n === "mainnet" && (n = "ethereum"), t ? `https://magiceden.io/item-details/${n}/${a}/${t}` : `https://magiceden.io/collections/${n}/${a}`;
}
const M = {
  [s.Mainnet]: "eth",
  [s.Optimism]: "oeth",
  [s.Matic]: "pol",
  [s.Base]: "base",
  [s.Sepolia]: "sep"
};
function u(e, a) {
  if (!g(e)) {
    const t = a === "contract" ? "getManifoldGalleryContractURL" : "getManifoldGalleryTokenURL";
    throw new Error(`Unsupported Network passed to ${t}`);
  }
  return `${p}/${M[e]}:`;
}
function E(e, a, t) {
  return `${u(e, "token")}${a}/${t}`;
}
function S(e, a) {
  return `${u(e, "contract")}${a}`;
}
function b(e) {
  return `${p}/${e}`;
}
function O(e, a, t) {
  if (!d.includes(e))
    throw new Error("Unsupported Network passed to getManifoldMarketplaceTokenURL");
  return `${f(e)}/${a}/${t}`;
}
function T(e, a, t) {
  if (![s.Mainnet, s.Matic, s.Base].includes(e))
    throw new Error("Unsupported Network passed to getRaribleTokenURL");
  return `https://rarible.com/token/${e === 1 ? "" : `${o(e)}/`}${a}:${t}`;
}
function W(e) {
  return e.includes("https://www.youtube.com") || e.includes("https://youtu.be") || e.includes("https://youtube.com") || e.includes("https://www.youtube-nocookie.com");
}
const x = (e, a) => {
  let t = e;
  if (t.includes("ipfs://ipfs/"))
    t = t.replace("ipfs://ipfs/", "https://ipfs.io/ipfs/");
  else if (t.includes("ipfs://"))
    t = t.replace("ipfs://", "https://ipfs.io/ipfs/");
  else if (t.includes("ipfs:\\/\\/"))
    t = t.replace("ipfs:\\/\\/", "https://ipfs.io/ipfs/");
  else if (t.includes("ar://"))
    t = t.replace("ar://", "https://arweave.net/");
  else if (t.includes("ar:\\/\\/"))
    t = t.replace("ar:\\/\\/", "https://arweave.net/");
  else if (a && t.includes("api.opensea.io/api/v1/metadata/") && t.includes("{id}")) {
    let n = a.toHexString();
    n = n.replace("0x", ""), t = t.replace("{id}", n);
  }
  return t;
};
function r(e) {
  e = e.trim();
  try {
    return JSON.parse(e);
  } catch {
  }
  try {
    return JSON.parse(unescape(e));
  } catch {
  }
  try {
    return JSON.parse(decodeURIComponent(e));
  } catch {
  }
  if (e.indexOf(`
`) !== -1) {
    e = e.replace(/\n/g, "\\n");
    try {
      return JSON.parse(e);
    } catch {
    }
    try {
      return JSON.parse(unescape(e));
    } catch {
    }
    try {
      return JSON.parse(decodeURIComponent(e));
    } catch {
    }
  }
  throw new Error(`Could not parse json: ${e}`);
}
function C(e) {
  let a;
  try {
    const t = e.toLowerCase();
    if (t.startsWith("data:"))
      if (t.startsWith("data:application/json;utf8,"))
        a = r(e.slice(27));
      else if (t.startsWith("data:application/json;utf-8,"))
        a = r(e.slice(28));
      else if (t.startsWith("data:application/json;charset=utf8,"))
        a = r(e.slice(35));
      else if (t.startsWith("data:application/json;charset=utf-8,"))
        a = r(e.slice(36));
      else if (t.startsWith("data:application/json;ascii,"))
        a = r(e.slice(28));
      else if (t.startsWith("data:application/json;charset=ascii,"))
        a = r(e.slice(36));
      else if (t.startsWith("data:application/json;base64,")) {
        const n = atob(e.slice(29));
        a = r(n);
      } else if (t.startsWith("data:text/plain,"))
        a = r(e.slice(16));
      else if (t.startsWith("data:application/json,"))
        a = r(e.slice(22));
      else if (t.startsWith("data:application/json;,"))
        a = r(e.slice(23));
      else
        throw new Error(`Unknown format for uri: ${e}`);
  } catch {
  }
  return a;
}
const F = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  convertPotentialWeb3ProtocolURLToWeb2URL: x,
  getEtherscanBaseURL: i,
  getEtherscanURLForAddress: l,
  getEtherscanURLForContract: k,
  getEtherscanURLForToken: L,
  getEtherscanURLForTransactionHash: w,
  getEtherscanURLForWallet: y,
  getLooksRareCollectionURL: $,
  getLooksRareTokenURL: m,
  getMagicEdenTokenURL: N,
  getManifoldGalleryContractURL: S,
  getManifoldGalleryTokenURL: E,
  getManifoldGalleryWalletURL: b,
  getManifoldMarketplaceBaseURL: f,
  getManifoldMarketplaceTokenURL: O,
  getOpenSeaBaseURL: c,
  getOpenSeaCollectionURL: U,
  getOpenSeaTokenURL: R,
  getRaribleTokenURL: T,
  isYoutubeVideoURL: W,
  parseOnChainMetadata: C
}, Symbol.toStringTag, { value: "Module" }));
export {
  N as a,
  m as b,
  T as c,
  R as d,
  l as e,
  c as f,
  E as g,
  U as h,
  $ as i,
  i as j,
  L as k,
  w as l,
  k as m,
  y as n,
  f as o,
  S as p,
  b as q,
  O as r,
  W as s,
  x as t,
  F as u,
  C as v
};
